import { render } from "./QuizView.vue?vue&type=template&id=054d4057&scoped=true"
import script from "./QuizView.vue?vue&type=script&lang=js"
export * from "./QuizView.vue?vue&type=script&lang=js"

import "./QuizView.vue?vue&type=style&index=0&id=054d4057&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054d4057"]])

export default __exports__